import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { ReplaySubject } from 'rxjs';
import { slideInAnimation } from 'src/app/route-animate';
import { ApiService } from 'src/app/services/api.service';
import { NotifyService } from 'src/app/services/notify.service';
import { ValueService } from 'src/app/services/value.service';
import { environment } from 'src/environments/environment';
import { ThemePalette } from '@angular/material/core';
interface incubDis {
  district: string;
}
@Component({
  selector: 'app-corporate-page',
  templateUrl: './corporate-page.component.html',
  styleUrls: ['./corporate-page.component.css'],
  animations: [slideInAnimation],
})
export class CorporatePageComponent implements OnInit {
  email = new FormControl('', [Validators.required, Validators.email]);
  colorControl = new FormControl('primary' as ThemePalette);
  getErrorMessage() {
    if (this.email.hasError('required')) {
      return 'You must enter a value';
    }
    return this.email.hasError('email') ? 'Not a valid email' : '';
  }
  corprateForm: FormGroup;
  private saveApi = environment.url + environment.incubatorProfileSave;
  public incubatorDistrictListValue = new ReplaySubject(1);
  protected incubatorDistrictList: incubDis[] = [];
  constructor(
    private httpClient: HttpClient,
    private fb: FormBuilder,
    private makeapi: ApiService,
    private getdata: ValueService,
    private notify: NotifyService
  ) {
    /**
     * Initializes the corporate form with the specified fields and validators.
     * - organizationName: Name of the organization.
     * - incubatorRegDesc: Description of the incubator registration.
     * - incubatorWebsite: Website of the incubator.
     * - incubatorYearofEstd: Year of establishment of the incubator.
     * - incubatorRegAddressLine1: Registration address line 1 of the incubator.
     * - incubatorDistrict: District where the incubator is located.
     * - incubatorOprState: State where the incubator operates.
     * - incubatorOprCountry: Country where the incubator operates.
     * - incubatorName: Name of the incubator.
     * - email: Contact email of the incubator.
     * - phone: Contact phone number of the incubator.
     * - incubatorTeamFirstName: First name of the incubator team lead.
     * - incubatorTeamEmail: Email of the incubator team lead.
     * - incubatorTeamPhone: Phone number of the incubator team lead.
     * - subSector: Sub-sector of the incubator.
     * - incubatorOprInterestedDistricts: List of districts of interest for operation.
     * - documents: Documents related to the incubator.
     */
    this.corprateForm = this.fb.group({
      organizationName: ['', [Validators.required]],
      incubatorRegDesc: ['', [Validators.required]],
      incubatorWebsite: ['', [Validators.required]],
      incubatorYearofEstd: [0, [Validators.required]],
      incubatorRegAddressLine1: ['', [Validators.required]],
      incubatorDistrict: ['', [Validators.required]],
      incubatorOprState: ['', [Validators.required]],
      incubatorOprCountry: ['', [Validators.required]],
      incubatorName: ['', [Validators.required]],
      email: ['', [Validators.required, Validators.email]],
      phone: [
        '',
        [
          Validators.required,
          Validators.pattern('^((\\+91-?)|0)?[0-9]{10,10}$'),
        ],
      ],
      incubatorTeamFirstName: ['', [Validators.required]],
      incubatorTeamEmail: ['', [Validators.required, Validators.email]],
      incubatorTeamPhone: [
        '',
        [
          Validators.required,
          Validators.pattern('^((\\+91-?)|0)?[0-9]{10,10}$'),
        ],
      ],
      subSector: [, [Validators.required]],
      incubatorOprInterestedDistricts: [[''], [Validators.required]],
      documents: ['', [Validators.required]],
    });

    /**
     * List of available sub-sectors.
     * @type {string[]}
     */
    this.subSectorValues = ['Incup-1', 'Incup-2', 'Incup-3'];
  }
  ngOnInit(): void {
    this.districtList();
    this.stateList();
  }

  get add() {
    return this.corprateForm.controls;
  }

  districtValues = [];
  /**
   * Fetches the list of districts from the assets/json/district.json file.
   * This file contains a JSON object with all the districts in India.
   * @returns {void}
   */
  districtList(): void {
    /**
     * The API endpoint to fetch the list of districts
     * @type {string}
     */
    const url: string = 'assets/json/district.json';

    /**
     * Fetch the list of districts from the API endpoint
     */
    this.httpClient.get<any>(url).subscribe((data) => {
      /**
       * Set the districtValues variable to the data received from the API call
       */
      this.districtValues = data;
    });
  }
  stateValue = [];
  statevalues;
  /**
   * Loads the list of states from the assets/json/Indian.json file.
   * This is a static file that contains the list of states in India.
   * @returns {void}
   */
  stateList(): void {
    /**
     * The API endpoint to fetch the list of states
     * @type {string}
     */
    const url: string = 'assets/json/Indian.json';

    /**
     * Fetch the list of states from the API endpoint
     * @returns {Observable<any>}
     */
    this.httpClient.get<any>(url).subscribe((data: any) => {
      /**
       * The list of states
       * @type {any[]}
       */
      this.stateValue = data;

      /**
       * The list of districts in the selected state
       * @type {any[]}
       */
      this.statevalues = this.stateValue[0].states;
    });
  }
  formData: any = {};
  subSectorValues = [];
  /**
   * Saves the form data by sending a POST request to the API.
   * Shows a loader and displays a success or error message based on the API response.
   */
  saveEvent() {
    // Get the form values
    let getform = this.corprateForm.value;

    // Check if the form is invalid
    if (this.corprateForm.invalid) {
      // Mark all the form fields as touched
      this.corprateForm.markAllAsTouched();
      // Display an error message
      this.notify.notifyError('Please fill all the mandatory fields !!');
    } else {
      // Create the request payload
      getform.subSector = getform.subSector;
      getform.incubatorOprInterestedDistricts = [
        getform.incubatorOprInterestedDistricts,
      ];
      getform.documents = [
        {
          id: 0,
          documentName: this.RegdisName,
          documentFile: this.RegFileValue,
        },
      ];

      // Show a loader
      this.getdata.amizhthLoader('show');
      // Send the POST request
      this.makeapi.method(this.saveApi, getform, 'post').subscribe((data) => {
        // Hide the loader
        this.getdata.amizhthLoader('hide');

        // Check the response status
        if (data.responseStatus == 'Success') {
          // Display a success message
          this.notify.notifysuccess(data.responseMessage);
          // Reset the form
          this.cancelEvent();
        } else {
          // Display an error message
          this.notify.notifyError(data.responseMessage);
        }
      });
    }
  }
  /**
   * Cancel the form and reset the values.
   */
  cancelEvent() {
    // Reset the form values
    this.corprateForm.reset();
  }
  selectedState: string = '';
  selectedCity: string = '';
  cities: any[] = [];
  /**
   * Select a state and update the list of cities.
   * @param state the selected state
   */
  onSelectState(state: string): void {
    // Update the selected state
    this.selectedState = state;

    // Find the selected state
    const selectedStateData = this.statevalues.find(
      (s) => s.stateName === this.selectedState
    );

    // Update the list of cities
    this.cities = selectedStateData.districts;

    // Clear the selected city
    this.selectedCity = '';
  }

  selecteddocFile: any = [];
  urlDoc: any;
  DocFileValue: any = '';
  DocFileName: any;
  documentDocValues = [];
  doc2Name;
  doc2Form;
  /**
   * Handles the file upload for the document.
   * Validates the file type, reads the file as a data URL,
   * and updates the form with the file's data and name.
   * @param event The file upload event.
   */
  doc2Upload(event) {
    this.selecteddocFile = event.target.files[0];
    if (event.target.files && this.selecteddocFile) {
      let reader = new FileReader();
      // Check if the file type is valid
      const imagetype = this.selecteddocFile.type;
      const imagedatatype = imagetype.split('/');
      const img_crt_type = imagedatatype[1];
      if (
        // Allow only the following file types
        img_crt_type == 'jpeg' ||
        img_crt_type == 'jpg' ||
        img_crt_type == 'png' ||
        img_crt_type == 'pdf'
      ) {
        // Read the file as a data URL
        reader.readAsDataURL(this.selecteddocFile);
        reader.onload = () => {
          // Split the data URL into its parts
          const spl = this.urlDoc.split(',');
          // Set the file value and name
          this.DocFileValue = spl[1];
          this.DocFileName = this.selecteddocFile.name;
          // Update the form with the uploaded file
          const getform = this.doc2Form.value;
          getform.DocFileName = this.selecteddocFile.name;
          getform.incubatorDocFile = this.DocFileValue;
          this.doc2Form.patchValue(getform);
        };
      } else {
        // Notify the user if the file type is not allowed
        this.notify.notifyError(
          'Only *jpeg,*jpg,*png,*pdf formets are allowed'
        );
      }
    }
  }
  selectedactdocFile: any = [];
  urlAct: any;
  ActFileValue: any = '';
  ActFileName: any;
  ActumentDocValues = [];
  actdocName;
  /**
   * Handles the file upload for the action document.
   * Validates the file type, reads the file as a data URL,
   * and updates the form with the file's data and name.
   * @param event - The file input change event for the action document.
   */
  actdocUpload(event) {
    // Select the file from the input event
    this.selectedactdocFile = event.target.files[0];
    if (event.target.files && this.selectedactdocFile) {
      let reader = new FileReader();
      // Get the file type and split it to get the extension
      let imagetype = this.selectedactdocFile.type;
      let imagedatatype = imagetype.split('/');
      let img_crt_type = imagedatatype[1];

      // Validate the file type
      if (
        img_crt_type == 'jpeg' ||
        img_crt_type == 'jpg' ||
        img_crt_type == 'png' ||
        img_crt_type == 'pdf'
      ) {
        // Read the file as a data URL
        reader.readAsDataURL(this.selectedactdocFile);
        reader.onload = () => {
          // On successful file read, update the URL and form values
          this.urlAct = reader.result;
          let spl = this.urlAct.split(',');
          this.ActFileValue = spl[1];
          this.ActFileName = this.selectedactdocFile.name;
          this.actdocName = this.selectedactdocFile.name;

          // Update the form with the uploaded file data
          let getform = this.corprateForm.value;
          getform.ActFileName = this.selectedactdocFile.name;
          getform.incubatorActFile = this.ActFileValue;
          this.corprateForm.patchValue(getform);
        };
      } else {
        // Notify the user if the file type is not allowed
        this.notify.notifyError(
          'Only *jpeg,*jpg,*png,*pdf formets are allowed'
        );
      }
    }
  }
  // other document
  selectedotherdocFile: any = [];
  urlOtherdoc: any;
  OtherdocFileValue: any = '';
  OtherdocFileName: any;
  documentOtherdocValues = [];
  otherdocName;
  /**
   * Handles the file upload for the other documents.
   * Validates the file type and size, reads the file as a data URL,
   * and updates the related variables with the file's data and name.
   * @param event - The file input change event for the other documents.
   */
  otherdocUpload(event) {
    this.selectedotherdocFile = event.target.files[0];
    if (event.target.files && this.selectedotherdocFile) {
      let reader = new FileReader();
      let imagetype = this.selectedotherdocFile.type;
      let imagedatatype = imagetype.split('/');
      let img_crt_type = imagedatatype[1];
      if (
        img_crt_type == 'jpeg' ||
        img_crt_type == 'jpg' ||
        img_crt_type == 'png' ||
        img_crt_type == 'pdf'
      ) {
        // Read the file as a data URL
        reader.readAsDataURL(this.selectedotherdocFile);
        reader.onload = () => {
          // On successful file read, update the URL and form values
          this.urlOtherdoc = reader.result;
          let spl = this.urlOtherdoc.split(',');
          this.OtherdocFileValue = spl[1];
          this.OtherdocFileName = this.selectedotherdocFile.name;
          this.otherdocName = this.selectedotherdocFile.name;
          // Update the form with the uploaded file
          let getform = this.corprateForm.value;
          getform.OtherdocFileName = this.selectedotherdocFile.name;
          getform.incubatorOtherdocFile = this.OtherdocFileValue;
          this.corprateForm.patchValue(getform);
        };
      } else {
        // If the file type is not valid, notify the user
        this.notify.notifyError(
          'Only *jpeg,*jpg,*png,*pdf formets are allowed'
        );
      }
    }
  }

  // Track record
  selectedtrackdocFile: any = [];
  urlTrack: any;
  TrackFileValue: any = '';
  TrackFileName: any;
  documentTrackValues = [];
  trackdocName;
  /**
   * Handles the file upload for the track record document.
   * Validates the file type and reads the file as a data URL,
   * then updates the related variables with the file's data and name.
   * @param event - The file input change event for the track record document.
   */
  trackdocUpload(event) {
    this.selectedtrackdocFile = event.target.files[0];
    if (event.target.files && this.selectedtrackdocFile) {
      let reader = new FileReader();
      let imagetype = this.selectedtrackdocFile.type;
      let imagedatatype = imagetype.split('/');
      let img_crt_type = imagedatatype[1];

      // Validate the file type
      if (
        img_crt_type == 'jpeg' ||
        img_crt_type == 'jpg' ||
        img_crt_type == 'png' ||
        img_crt_type == 'pdf'
      ) {
        // Read the file as a data URL
        reader.readAsDataURL(this.selectedtrackdocFile);
        reader.onload = () => {
          this.urlTrack = reader.result;
          let spl = this.urlTrack.split(',');
          this.TrackFileValue = spl[1];
          this.TrackFileName = this.selectedtrackdocFile.name;
          this.trackdocName = this.selectedtrackdocFile.name;
          let getform = this.corprateForm.value;
          getform.TrackFileName = this.selectedtrackdocFile.name;
          getform.incubatorTrackFile = this.TrackFileValue;
          this.corprateForm.patchValue(getform);
        };
      } else {
        // Notify the user of an invalid file type
        this.notify.notifyError(
          'Only *jpeg,*jpg,*png,*pdf formets are allowed'
        );
      }
    }
  }

  selecetdFile: any = [];
  url: any;
  FileValue: any = '';
  FileName: any;
  documentValues = [];
  disName;

  /**
   * Handles the file upload for the first file input.
   * Validates the file type and reads the file as a data URL,
   * then updates the related variables with the file's data and name.
   * @param event - The file input change event for the first file input.
   */
  fileUpload(event) {
    this.selecetdFile = event.target.files[0];
    if (event.target.files && this.selecetdFile) {
      let reader = new FileReader();
      let imagetype = this.selecetdFile.type;
      let imagedatatype = imagetype.split('/');
      let img_crt_type = imagedatatype[1];

      // Validate the file type
      if (
        img_crt_type == 'jpeg' ||
        img_crt_type == 'jpg' ||
        img_crt_type == 'png' ||
        img_crt_type == 'pdf'
      ) {
        // Read the file as a data URL
        reader.readAsDataURL(this.selecetdFile);
        reader.onload = () => {
          this.url = reader.result;
          let spl = this.url.split(',');
          this.FileValue = spl[1];
          this.FileName = this.selecetdFile.name;
          this.disName = this.selecetdFile.name;
        };
      } else {
        // Notify the user if the file type is not valid
        this.notify.notifyError(
          'Only *jpeg,*jpg,*png,*pdf formats are allowed'
        );
      }
    }
  }

  disName2;
  selecetdFile2: any = [];
  FileValue2: any = '';
  FileName2: any;
  documentValues2 = [];
  /**
   * Handles the file upload for the second file input.
   * Validates the file type and reads the file as a data URL,
   * then updates the related variables with the file's data and name.
   * @param event2 - The file input change event for the second file input.
   */
  fileUpload2(event2) {
    // Select the first file from the second file input
    this.selecetdFile2 = event2.target.files2[0];

    if (event2.target.files2 && this.selecetdFile2) {
      // Create a new FileReader instance
      let reader = new FileReader();

      // Extract the file type and format
      let imagetype = this.selecetdFile2.type;
      let imagedatatype = imagetype.split('/');
      let img_crt_type = imagedatatype[1];

      // Validate the file type
      if (
        img_crt_type == 'jpeg' ||
        img_crt_type == 'jpg' ||
        img_crt_type == 'png' ||
        img_crt_type == 'pdf'
      ) {
        // Read the file as a data URL
        reader.readAsDataURL(this.selecetdFile2);
        reader.onload = () => {
          // On successful file read, update the URL and file data
          this.url = reader.result;
          let spl = this.url.split(',');
          this.FileValue2 = spl[1];
          this.FileName2 = this.selecetdFile2.name;
          this.disName2 = this.selecetdFile2.name;
        };
      } else {
        // Notify the user if the file type is not allowed
        this.notify.notifyError(
          'Only *jpeg,*jpg,*png,*pdf formats are allowed'
        );
      }
    }
  }
  selectedFiles: { [key: string]: File | null } = {
    file1: null,
    file2: null,
    file3: null,
    file4: null,
    file5: null,
  };
  selecetdRegFile: any = [];
  urlReg: any;
  RegFileValue: any = '';
  RegFileName: any;
  documentRegValues = [];
  RegdisName;
  /**
   * Handles the file upload for the registration document.
   * Validates the file type and reads the file as a data URL,
   * then updates the form with the uploaded file.
   * @param event - The file input change event.
   */
  fileRegUpload(event) {
    // Select the first file from the event
    this.selecetdRegFile = event.target.files[0];

    if (event.target.files && this.selecetdRegFile) {
      // Create a new FileReader instance
      let reader = new FileReader();

      // Extract the file type and format
      let imagetype = this.selecetdRegFile.type;
      let imagedatatype = imagetype.split('/');
      let img_crt_type = imagedatatype[1];

      // Validate the file type
      if (
        img_crt_type == 'jpeg' ||
        img_crt_type == 'jpg' ||
        img_crt_type == 'png' ||
        img_crt_type == 'pdf'
      ) {
        // Read the file as a data URL
        reader.readAsDataURL(this.selecetdRegFile);
        reader.onload = () => {
          // On successful file read, update the URL and form values
          this.urlReg = reader.result;
          let spl = this.urlReg.split(',');
          this.RegFileValue = spl[1];
          this.RegFileName = this.selecetdRegFile.name;
          this.RegdisName = this.selecetdRegFile.name;

          // Patch the form with the new file data
          let getform = this.corprateForm.value;
          getform.documentsRegFileName = this.selecetdRegFile.name;
          getform.documentsRegFile = this.RegFileValue;
          this.corprateForm.patchValue(getform);
        };
      } else {
        // Notify the user if the file type is not allowed
        this.notify.notifyError(
          'Only *jpeg,*jpg,*png,*pdf formats are allowed'
        );
      }
    }
  }
  selecetdTwelFile: any = [];
  urlTwel: any;
  TwelFileValue: any = '';
  TwelFileName: any;
  TweldisName;
  /**
   * Handles the file upload for the 12AA and 80G certificate document.
   * Validates the file type and size, reads the file as a data URL,
   * and updates the form with the uploaded file.
   * @param event - The file input change event.
   */
  twelldocfileUpload(event) {
    this.selecetdTwelFile = event.target.files[0];
    if (event.target.files && this.selecetdTwelFile) {
      const reader = new FileReader();
      const imagetype = this.selecetdTwelFile.type;
      const imagedatatype = imagetype.split('/');
      const img_crt_type = imagedatatype[1];

      // Validate the file type
      if (
        img_crt_type === 'jpeg' ||
        img_crt_type === 'jpg' ||
        img_crt_type === 'png' ||
        img_crt_type === 'pdf'
      ) {
        reader.readAsDataURL(this.selecetdTwelFile);
        reader.onload = () => {
          // On successful file read, update the URL and form values
          this.urlTwel = reader.result;
          const spl = this.urlTwel.split(',');
          this.TwelFileValue = spl[1];
          this.TwelFileName = this.selecetdTwelFile.name;
          this.TweldisName = this.selecetdTwelFile.name;
          const getform = this.corprateForm.value;
          getform.twlaa80gDocuments = this.TwelFileValue;
          this.corprateForm.patchValue(getform);
        };
      } else {
        // Notify the user if the file type is not allowed
        this.notify.notifyError(
          'Only *jpeg,*jpg,*png,*pdf formats are allowed'
        );
      }
    }
  }
  // new Action part
  selecetdActionFile: any = [];
  urlAction: any;
  ActionFileValue: any = '';
  ActionFileName: any;
  ActiondisName;
  /**
   * Handles the file upload for the action plan document.
   * Validates the file type and reads the file as a data URL,
   * then updates the form with the uploaded file.
   * @param event - The file input change event.
   */
  actiondocfileUpload(event) {
    this.selecetdActionFile = event.target.files[0];
    if (event.target.files && this.selecetdActionFile) {
      const reader = new FileReader();
      const imagetype = this.selecetdActionFile.type;
      const imagedatatype = imagetype.split('/');
      const img_crt_type = imagedatatype[1];

      // Validate the file type
      if (
        img_crt_type === 'jpeg' ||
        img_crt_type === 'jpg' ||
        img_crt_type === 'png' ||
        img_crt_type === 'pdf'
      ) {
        reader.readAsDataURL(this.selecetdActionFile);
        reader.onload = () => {
          // On successful file read, update the URL and form values
          this.urlAction = reader.result;
          const spl = this.urlAction.split(',');
          this.ActionFileValue = spl[1];
          this.ActionFileName = this.selecetdActionFile.name;
          this.ActiondisName = this.selecetdActionFile.name;
          const getform = this.corprateForm.value;
          getform.actionPlanDocuments = this.ActionFileValue;
          this.corprateForm.patchValue(getform);
        };
      } else {
        // Notify the user if the file type is not allowed
        this.notify.notifyError(
          'Only *jpeg,*jpg,*png,*pdf formets are allowed'
        );
      }
    }
  }
  // new Track Record
  selecetdTrackrecFile: any = [];
  urlTrackrec: any;
  TrackrecFileValue: any = '';
  TrackrecFileName: any;
  TrackrecdisName;
  /**
   * Handles the file upload for the track record document.
   * Validates the file type and reads the file as a data URL,
   * then updates the form with the uploaded file.
   * @param event The file upload event.
   */
  trackrecdocfileUpload(event) {
    this.selecetdTrackrecFile = event.target.files[0];
    if (event.target.files && this.selecetdTrackrecFile) {
      let reader = new FileReader();
      let imagetype = this.selecetdTrackrecFile.type;
      let imagedatatype = imagetype.split('/');
      let img_crt_type = imagedatatype[1];

      // Check for valid image types
      if (
        img_crt_type == 'jpeg' ||
        img_crt_type == 'jpg' ||
        img_crt_type == 'png' ||
        img_crt_type == 'pdf'
      ) {
        reader.readAsDataURL(this.selecetdTrackrecFile);
        reader.onload = () => {
          // On successful file read, update the URL and form values
          this.urlTrackrec = reader.result;
          let spl = this.urlTrackrec.split(',');
          this.TrackrecFileValue = spl[1];
          this.TrackrecFileName = this.selecetdTrackrecFile.name;
          this.TrackrecdisName = this.selecetdTrackrecFile.name;

          // Update the form with the uploaded file
          let getform = this.corprateForm.value;
          getform.trackRecordDocuments = this.TrackrecFileValue;
          this.corprateForm.patchValue(getform);
        };
      } else {
        // Notify user of invalid file type
        this.notify.notifyError(
          'Only *jpeg,*jpg,*png,*pdf formats are allowed'
        );
      }
    }
  }

  //  Other Records document
  selecetdOtherrecFile: any = [];
  urlOtherrec: any;
  OtherrecFileValue: any = '';
  OtherrecFileName: any;
  OtherrecdisName;
  /**
   * Handles the file upload for the other records document.
   * Validates the file type and size, reads the file as a data URL,
   * and updates the form with the uploaded file.
   * @param event The file upload event.
   */
  otherrecdocfileUpload(event) {
    this.selecetdOtherrecFile = event.target.files[0];
    if (event.target.files && this.selecetdOtherrecFile) {
      // Read the file as a data URL
      let reader = new FileReader();
      let imagetype = this.selecetdOtherrecFile.type;
      let imagedatatype = imagetype.split('/');
      let img_crt_type = imagedatatype[1];
      if (
        img_crt_type == 'jpeg' ||
        img_crt_type == 'jpg' ||
        img_crt_type == 'png' ||
        img_crt_type == 'pdf'
      ) {
        reader.readAsDataURL(this.selecetdOtherrecFile);
        reader.onload = () => {
          // On successful file read, update the URL and form values
          this.urlOtherrec = reader.result;
          let spl = this.urlOtherrec.split(',');
          this.OtherrecFileValue = spl[1];
          this.OtherrecFileName = this.selecetdOtherrecFile.name;
          this.OtherrecdisName = this.selecetdOtherrecFile.name;
          let getform = this.corprateForm.value;
          getform.OtherDocuments = this.OtherrecFileValue;
          // Update the form with the uploaded file
          this.corprateForm.patchValue(getform);
        };
      } else {
        // If the file type is not valid, notify the user
        this.notify.notifyError(
          'Only *jpeg,*jpg,*png,*pdf formets are allowed'
        );
      }
    }
  }
}
